import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('Sending...');


    try {
      // n8n webhook endpoint
      const endpoint = 'https://n8n.thechessrepublic.com/webhook/39cd23ee-3d95-4e5d-bfcb-e9855886b9cb';
      
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
        mode: 'cors'
      });

      if (response.ok) {
        // Track successful contact form submission in GA4
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'contact_form_submitted', {
            method: 'contact_api',
            outcome: 'success'
          });
        }
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('Failed to send message, please try again');
      }
    } catch (error) {
      setStatus('Network error, please try again');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="max-w-lg mx-auto">
      <motion.h2 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="text-2xl font-semibold text-gray-100 mb-6 text-center"
      >
        Send a Message
      </motion.h2>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.15 }}
        className="text-gray-300 text-sm mb-8 text-center"
      >
        <ul className="space-y-2">
          <li>• Request a new listing</li>
          <li>• Request updates to an existing listing</li>
          <li>• Advertise a chess product on our platform</li>
        </ul>
      </motion.div>
      
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        onSubmit={handleSubmit}
        className="mt-6"
      >
        <div className="space-y-4">
        <div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-gray-100 placeholder-gray-500 focus:outline-none focus:border-gray-500 transition-colors"
            autoComplete="name"
          />
        </div>

        <div>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-gray-100 placeholder-gray-500 focus:outline-none focus:border-gray-500 transition-colors"
            autoComplete="email"
          />
        </div>

        <div>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
            required
            rows="6"
            maxLength="5000"
            className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-gray-100 placeholder-gray-500 focus:outline-none focus:border-gray-500 transition-colors resize-none"
          />
          <div className="text-right text-sm text-gray-500 mt-1">
            {formData.message.length}/5000
          </div>
        </div>


        <button
          type="submit"
          disabled={loading || !formData.message.trim()}
          className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-700 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors duration-200"
        >
          {loading ? 'Sending...' : 'Send Message'}
        </button>

        {status && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={`text-center mt-4 ${
              status.includes('success') ? 'text-green-400' : 
              status.includes('error') || status.includes('limit') ? 'text-red-400' : 
              'text-gray-400'
            }`}
            role="status"
            aria-live="polite"
          >
            {status}
          </motion.div>
        )}
      </div>
    </motion.form>
    </div>
  );
};

export default ContactForm;